import { render, staticRenderFns } from "./SectionEditDeleteButton.vue?vue&type=template&id=2b991e23&"
import script from "./SectionEditDeleteButton.vue?vue&type=script&lang=js&"
export * from "./SectionEditDeleteButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports